interface StatCardProps {
  label: string;
  value: string | number;
  change?: string;
  changeType?: "positive" | "negative" | "neutral";
  icon: string;
  iconBg: string;
  iconColor: string;
  colorAccent?: string;
}

export default function StatCard({
  label,
  value,
  change,
  changeType = "neutral",
  icon,
  iconBg,
  iconColor,
  colorAccent,
}: StatCardProps) {
  const changeColor =
    changeType === "positive"
      ? "text-primary-600"
      : changeType === "negative"
      ? "text-danger-500"
      : "text-foreground-500";

  return (
    <div className="relative bg-white rounded-xl p-5 border border-background-200/70 hover:border-background-300/60 transition-all duration-200 cursor-pointer group">
      {colorAccent && (
        <div
          className={`absolute top-0 left-0 right-0 h-1 rounded-t-xl ${colorAccent}`}
        ></div>
      )}
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-foreground-500 font-medium mb-2 truncate">{label}</p>
          <h3 className="text-2xl font-bold text-foreground-900 tracking-tight">
            {typeof value === "number" ? value.toLocaleString("pt-BR") : value}
          </h3>
          {change && (
            <p className={`text-xs mt-1.5 font-medium ${changeColor}`}>
              {changeType === "positive" && <i className="ri-arrow-up-line mr-0.5"></i>}
              {changeType === "negative" && <i className="ri-arrow-down-line mr-0.5"></i>}
              {change}
            </p>
          )}
        </div>
        <div
          className={`w-10 h-10 rounded-lg ${iconBg} flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform duration-200`}
        >
          <i className={`${icon} ${iconColor} text-lg`}></i>
        </div>
      </div>
    </div>
  );
}